export const upToTwoDecimalPlaces = (val: number | string) => !!(val + '').match(/^[0-9]+(\.[0-9][0-9]?)?$/);
export const upToThreeDecimalPlaces = (val: number | string) => !!(val + '').match(/^[0-9]+(\.[0-9]{0,3})?$/);
